import { alertRequest, body, request } from "services/request";

const resource = "api/bids";
const cargobids = "api/cargobids";

export const getCargoBidForEdit = (id: string) => request(`${cargobids}/get/${id}`, { method: "GET" });

export const applyOpenBid = (params: {}, alertParams?: { successAlerts: boolean; noContentAlerts: boolean }) =>
    alertRequest(`${cargobids}/apply`, body(params), alertParams);

export const getOpenBidByChatId = (id: string) => request(`${resource}/getOpenBidByChatId/${id}`, { method: "GET" });

export const getBidChatInfo = (id: string) => request(`${resource}/getBidChatInfo/${id}`, { method: "GET" });
